import { Component, Input } from '@angular/core';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';
import { WarehousePropertyDetailConstant } from './warehouse-property-detail.constant';
import { ReportService } from 'src/app/reports/services/report.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { Subject, takeUntil } from 'rxjs';
import { WarehousePropertyDetailMenuEnum } from './warehouse-property-detail.enum';
import { PropertyCategoryEnum } from '../../propertyCategory.enum';
import { ApiService } from 'src/app/common/services/api.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { TranslateService } from '@ngx-translate/core';
import { WarehousePropertyDetailService } from './warehouse-property-detail.service';

@Component({
  selector: 'app-warehouse-property-detail',
  templateUrl: './warehouse-property-detail.component.html',
  styleUrls: ['./warehouse-property-detail.component.scss']
})
export class WarehousePropertyDetailComponent {
  @Input() propertyInfo: any; // Input property to receive property details from parent
  currentLang: string = '';
  currentReportView: number = ReportsViewEnum.mapView;
  overViewMenu = WarehousePropertyDetailConstant.overViewMenu;
  currentScroll: any = '';
  WarehousePropertyDetailMenuEnum = WarehousePropertyDetailMenuEnum;
  PropertyCategoryEnum = PropertyCategoryEnum;
  // Dropdown configuration for price display type (Range/Average)
  rentUnitSizeWiseDropdown = WarehousePropertyDetailConstant.rentUnitSizeWiseDropdown;
  // Subject to trigger unsubscription for all observables on destroy
  private destroy$ = new Subject<void>();
  // Table columns for the "Rent Unit Size Wise" section (default: Range)
  rentUnitSizeWiseColumn = WarehousePropertyDetailConstant.rentUnitSizeWiseColumnRange;
  warehousePropertydetailData: any[] = [];
  warehousePropertyDetailLoading: boolean = false;
  userInfo: any = 0;
  placeCode: string = '';
  warehousePropertydetailCount: number = 0;
  propertydeatildataCount: any = [];
  downloadLoading: boolean = false;

  constructor(
    public reportService: ReportService,
    public sharedService: SharedService,
    private apiService: ApiService,
    private alertService: AlertService,
    public translate: TranslateService,
    public WarehousePropertyDetailService: WarehousePropertyDetailService
  ) {
    //Overview menu text update yearly & montly case
    if (sharedService.priceCalculation$() === this.sharedService.priceYearly) {
      this.overViewMenu[1]['label'] = 'reports.annualRentUnitSizeWise';
    }
  }

  /**
   * Lifecycle hook: OnInit
   * Initializes component state, subscribes to report view, and fetches initial data.
   */
  ngOnInit(): void {
    // this.setLang(); // (Commented out, can be enabled if needed)
    this.getReportView();
    this.getRentUnitSizeWise();
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
  }

  /**
   * Fetches the "Rent Unit Size Wise" data for the current property.
   * Handles loading state and data formatting.
   */
  getRentUnitSizeWise() {
    this.warehousePropertyDetailLoading = true;
    this.WarehousePropertyDetailService.getWarehousePropertyDetail(this.propertyInfo?.property_uid)
      .pipe(takeUntil(this.destroy$)) // Unsubscribe on destroy
      .subscribe({
        next: (res: any) => {
           this.warehousePropertyDetailLoading = false;
          if (res.status === 200) {
            if (res.data) {
              // Format range columns for display
              let cols = [
                'dry_warehouse_range',
                'cold_storage_range',
                'frozen_warehouse_range',
                'ambient_type_range',
              ];
              res.data.map((el: any) => {
                Object.keys(el).map((e: any) => {
                  if (cols.includes(e)) {
                    el[e] = this.reportService.rangeToNumberFor(el[e]);
                  }
                });
              });
            }
            this.warehousePropertydetailData =res.data;
          } else {
            // Reset data on error
            this.warehousePropertydetailData = [];           
          }
         
        },
        error: (error: any) => {
          // Reset data on error
          this.warehousePropertydetailData = [];
          this.warehousePropertyDetailLoading = false;
        }
      });
  }

  /**
   * Initiates download of the warehouse property report in the specified format.
   * @param type The type of report to download (e.g., 'excel', 'pdf')
   */
  downloadExcel(type: string) {
    this.downloadwarehousePropertyReport(type, this.propertyInfo?.property_uid);
  }

  /**
   * Handles the download process for the warehouse property report.
   * Shows loading, triggers download, and displays alerts.
   * @param type The type of report to download
   * @param property_uid The unique identifier for the property
   */
  downloadwarehousePropertyReport(type: string, property_uid: any) {
    this.downloadLoading = true;
    this.reportService.downloadReport(type, this.userInfo?.user_id, "" ,property_uid).subscribe({
      next: (res: any) => {
        this.downloadLoading = false;
        if (res.status === 200) {
          // Construct download URL and trigger download
          const downloadUrl = `${this.sharedService.downloadExcelPath()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=warehouse_rental`;
          this.sharedService.downloadExcelUrl(downloadUrl);
          this.alertService.success(this.translate.instant('reports.downloadRequestSubmitted'));
        } else {
          this.alertService.warn(res.message);
        }
      },
      error: (error: any) => {
        this.downloadLoading = false;
      }
    });
  }

  /**
   * Navigates back to the transaction/property list view.
   */
  backToTransaction() {
    if(!this.reportService.projectReportView){
       this.reportService.isDetailPageOpen = false;
    }  
    // this.reportService.isDetailPageOpen = false;
    this.reportService.transactionPropertyDetails.next(false);
  }

  /**
   * Subscribes to the report view observable to track current report view (map/grid).
   */
  getReportView() {
    this.reportService.reportView$
      .pipe(takeUntil(this.destroy$))
      .subscribe((view: number) => {
        this.currentReportView = view;
      });
  }

  /**
   * Handles menu tab change and scrolls to the selected section.
   * @param menu The selected menu item
   */
  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    });
  }

  /**
   * Scrolls the page to the specified menu section.
   * @param menu The menu section to scroll to
   */
  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }

  /**
   * Handles dropdown selection change for price display type (Range/Average).
   * Updates the table columns accordingly.
   * @param value The selected dropdown value
   */
  selectionChange(value: any) {
    if (value === 'Range') {
      this.rentUnitSizeWiseColumn = WarehousePropertyDetailConstant.rentUnitSizeWiseColumnRange;
    } else {
      this.rentUnitSizeWiseColumn = WarehousePropertyDetailConstant.rentUnitSizeWiseColumnAverage;
    }
  }

  /**
   * Lifecycle hook: OnDestroy
   * Cleans up all subscriptions to prevent memory leaks.
   */
  ngOnDestroy() {
    this.destroy$.next(); // Emit signal to unsubscribe
    this.destroy$.complete(); // Clean up the Subject
  }
}